import src from "IMAGE";
export default { src, width: 864, height: 480, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAS0lEQVR42m2MQQqAIBREf7sK6k6doGW7zhakd3AjCB7s+UUERRcPhuHNiHxQOSycytJ0UsP2wxvhCbCbibCqcDm4fZEHId/mZbdWEvvmVfICRKt4AAAAAElFTkSuQmCC"};
